var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-contain"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("components.Privacy.text")))]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.language == "zh-CN" ? _vm.text : _vm.text2)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }